import React from 'react'
import { connect } from 'react-redux'
import Mandates from '../../../../../containers/CustomerScreen/components/Mandates/Mandates'
import { getAllMandatesRequest } from '../../../../../containers/CustomerScreen/actions.es6'

// The generic customer screen already shows a customer's mandates and debit orders (with links to their
// collections history). This customer status page replaces that screen for this partner, so it hosts the
// same component, fed from the same store slice.
const CustomerMandates = ({ msisdn, mandates, loader, dispatch }) => (
  <Mandates
    msisdn={msisdn}
    getMandates={number => dispatch(getAllMandatesRequest(number))}
    mandates={mandates}
    mandatesLoader={loader}
  />
)

const mapStateToProps = state => ({
  mandates: state.customerScreen.mandates,
  loader: state.customerScreen.get_mandates_loader
})

export default connect(mapStateToProps)(CustomerMandates)
